/** @format */

import React, { useEffect } from 'react';
import { Grid, Button, Typography, Card, CardContent } from '@mui/material';
import { ButtonLoading, SimpleDialog, Icons, PriceLabel } from 'components';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { numberWithCommas } from 'utility';
import clsx from 'clsx';
import { useStyles } from './style';
import Services from '../../services/ReceivedSubscriptionsServices';
import createToast from 'components/Toast/Toast';
import useCustomHook from '../../../hooks';
import { getDynamicObjectAction } from 'utility';
import { useNavigate } from 'react-router-dom';
export default function ReceivedSubscriptionItem({ data, onhandleRefresh, currencyText }) {
  const {
    open,
    setOpen,
    days,
    setDays,
    count,
    setCount,
    countPercent,
    setCountPercent,
    amountPercent,
    setAmountPercent,
    loadingBtn,
    setLoadingBtn,
  } = useCustomHook();

  const actionsList = getDynamicObjectAction(['detailActiveSubscriptionsBtn']);
  const navigate = useNavigate();
  const statusType = {
    SUBSCRIPTION_NOT_VERIFY: 'در انتظار تایید',
    SUBSCRIPTION_TIMEOUTED: 'منقضی شده',
    SUBSCRIPTION_CONFIRM: 'تایید شده',
    SUBSCRIPTION_EXPIRED: 'به اتمام رسیده',
    SUBSCRIPTION_REJECTED: 'رد شده',
    SUBSCRIPTION_REVOKED: 'لغو شده',
  };
  const statusPane = {
    SUBSCRIPTION_PLAN_TYPE_BLOCK: 'مسدودی',
    SUBSCRIPTION_PLAN_TYPE_CASH: 'نقدی',
    SUBSCRIPTION_PLAN_TYPE_POST_PAID: 'پس پرداخت',
  };
  const classes = useStyles();
  useEffect(() => {
    getDays();
    createCount();
    createPercent();
  }, []);
  const getDays = () => {
    const now = new Date();
    if (data.toDate && new Date(data.toDate) >= now) {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const diffDays = Math.round(Math.abs((now - new Date(data.toDate)) / oneDay));
      setDays(diffDays);
    }
  };
  const createCount = () => {
    if (data.plan.usageCountLimit && data.usageCount) {
      const val =
        numberWithCommas(data.usageCount) +
        ' از ' +
        numberWithCommas(data.plan.usageCountLimit) +
        ' نوبت ';
      setCount(val);
    }
  };
  const createPercent = () => {
    if (data.plan.usageCountLimit) {
      const countPercent = Math.round((data.usageCount / data.plan.usageCountLimit) * 100);
      setCountPercent(countPercent);
    } else {
      setCountPercent(0);
    }
    if (data.plan.usageAmountLimit) {
      const pricePercent = Math.round((data.usedAmount / data.plan.usageAmountLimit) * 100);
      setAmountPercent(pricePercent);
    } else {
      setAmountPercent(0);
    }
  };
  const payDialog = () => {
    setOpen(true);
  };

  const ChangeStateActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          name="بله"
          loading={loadingBtn}
          onClick={onAccept}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };
  const onAccept = () => {
    setLoadingBtn(true);
    Services.subscriptionPayment(data?.id)
      .then((res) => {
        createToast('موفق', 'پرداخت با موفقیت انجام شد', 'success');

        setOpen(false);
        setLoadingBtn(false);
        onhandleRefresh();
      })
      .catch((error) => {
        setOpen(false);
        setLoadingBtn(false);
      });
  };
  const handleCloseDialog = () => {
    setOpen(false);
  };
  const goShowDetails = () => {
    navigate(`/subscriptions/received/${data.id}?planId=${data.plan.id}`);
  };
  return (
    <Card xs={12} className={clsx(classes.root, {})}>
      <CardContent className={clsx(classes.content, {})}>
        {}
        <Grid container justifyContent="space-between" alignItems="center" className={classes.cardHeader}>
          <Grid item className={classes.titlePart}>
            <Typography variant="h6" className={classes.subtitleText}>
              {data?.plan?.name}
            </Typography>
          </Grid>
          <Grid item className={classes.titleActions}>
            <Grid className={classes.typePlan}>نوع طرح : {statusPane[data?.plan?.typeCode]}</Grid>
            <Grid>{statusType[data?.status]}</Grid>
          </Grid>
        </Grid>

        <div className={classes.cardInside}>
          {/* Status */}
          <Grid
            item
            container
            alignItems="center"
            className={clsx(classes.propertyContainer, {})}
            onClick={() => {}}
          >
            <div className={classes.boxChart}>
              <div style={{ display: 'flex' }}>
                {}
                <CircularProgressbarWithChildren
                  value={countPercent}
                  strokeWidth={6}
                  styles={buildStyles({
                    pathColor: `${
                      countPercent >= 90
                        ? '#FC3308'
                        : countPercent >= 80 && countPercent < 90
                        ? '#FC9408'
                        : '#006cfc'
                    }`,
                  })}
                >
                  {data?.plan?.usageCountLimit ? (
                    <>
                      <div className={classes.blueLight}>{data?.usageCount}</div>
                      <div className={classes.textProgress}>از</div>
                      <div className={classes.textProgress}>
                        {numberWithCommas(data?.plan?.usageCountLimit)} بار
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={classes.blueLight}>{numberWithCommas(data?.usageCount)}</div>
                      <div className={classes.textProgress}>بار استفاده</div>
                    </>
                  )}
                </CircularProgressbarWithChildren>
              </div>
              <div style={{ display: 'flex' }}>
                {}
                <CircularProgressbarWithChildren
                  value={amountPercent}
                  strokeWidth={6}
                  styles={buildStyles({
                    pathColor: `${
                      amountPercent >= 90
                        ? '#FC3308'
                        : amountPercent >= 80 && amountPercent < 90
                        ? '#FC9408'
                        : '#3870ba'
                    }`,
                  })}
                >
                  {data?.plan?.usageAmountLimit ? (
                    <>
                      <div
                        className={classes.messagePercent}
                        style={{ fontSize: 12, marginTop: -5 }}
                      >
                        <div className={classes.blueColor}>
                          <PriceLabel amount={data?.usedAmount} />
                        </div>
                        <div className={classes.textProgress}>از</div>
                        <div className={classes.textProgress}>
                          <PriceLabel
                            amount={data?.plan?.usageAmountLimit}
                            currency={currencyText}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        className={classes.messagePercent}
                        style={{ fontSize: 12, marginTop: -5 }}
                      >
                        <div className={classes.blueColor}>
                          <PriceLabel amount={data?.usedAmount} />
                        </div>
                        <div className={classes.textProgress}> {currencyText}</div>
                      </div>
                    </>
                  )}
                </CircularProgressbarWithChildren>
              </div>
            </div>
          </Grid>

          {/* Balances */}
          <Grid container justifyContent="space-between" style={{ paddingBottom: 2 * 8 }}>
            <Grid className={classes.textCenter} item xs={12} md={6}>
              <Typography className={classes.balanceTitle}>دفعات استفاده شده</Typography>
              {}
            </Grid>
            <Grid className={classes.textCenter} item xs={12} md={6}>
              <Typography className={classes.balanceTitle}>مبلغ استفاده </Typography>
              {}
            </Grid>
          </Grid>
          <Typography className={classes.blockedAmount}>
            <span className={classes.grayColor}> میزان مصرف :</span>{' '}
            <span style={{ marginRight: '8px' }} className={classes.grayLight}>
              {count || ' - '}
            </span>
          </Typography>
          <Typography className={classes.blockedAmount}>
            <span className={classes.grayColor}> زمان باقیمانده :</span>
            <span className={classes.grayLight} style={{ marginRight: '8px' }}>
              {data.status == 'SUBSCRIPTION_CONFIRM' && days ? ` ${days} روز باقیمانده ` : ' - '}
            </span>
          </Typography>
          <div className={classes.blockedAmount}>
            <span className={classes.grayColor}> میزان کل بدهی :</span>
            <span className={classes.grayLight} style={{ marginRight: '8px' }}>
              {data?.notSettledUsedAmount > 0 ? (
                <PriceLabel amount={data?.notSettledUsedAmount} currency={currencyText} />
              ) : (
                'بدهی ندارد'
              )}
            </span>
            {data?.plan?.typeCode == 'SUBSCRIPTION_PLAN_TYPE_POST_PAID' &&
              data?.notSettledUsedAmount > 0 && (
                <a className={classes.amountPaid} onClick={payDialog}>
                  پرداخت بدهی
                </a>
              )}
          </div>
          {actionsList['detailActiveSubscriptionsBtn'] && (
            <div
              style={{
                marginTop: '16px',
                display: 'flex',
                color: '#589df9',
                cursor: 'pointer',
                fontSize: '12px',
                alignItems: 'center',
              }}
              onClick={goShowDetails}
            >
              اطلاعات کامل
              <Icons icon="CaretLeft" color="#2b3990" size="23" />
            </div>
          )}
        </div>
      </CardContent>

      <SimpleDialog
        title={'پرداخت بدهی'}
        content={`آیا می‌خواهید مبلغ  ${data?.notSettledUsedAmount} ${currencyText}  را از کیف پول خود پرداخت کنید؟`}
        open={open}
        actions={<ChangeStateActionBtn />}
      />
    </Card>
  );
}
